





























import {Vue, Component} from 'vue-property-decorator'
import Footers from '@/components/Footers.vue'
import Logo from '@/components/common/Logo.vue';

@Component({
  name: 'PageNotFound',
  components: { Logo, Footers}
})
export default class PageNotFound extends Vue {
  private back2Prev() {
    this.$router.back()
  }

  private back2Main() {
    this.$router.replace('/')
  }
}
